(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 768px)');

  function getViewportPadding(viewport) {
    var styles = window.getComputedStyle(viewport);
    return parseFloat(styles.paddingLeft || styles.paddingInlineStart || '0') || 0;
  }

  function initGallery(root) {
    if (!root || root.dataset.pdpGalleryInit === 'true') return;

    var viewport = root.querySelector('[data-pdp-gallery-viewport]');
    var track = root.querySelector('[data-pdp-gallery-track]');
    var slides = track ? track.querySelectorAll('[data-pdp-gallery-slide]') : [];
    var dots = root.querySelectorAll('[data-pdp-gallery-dot]');
    var thumbs = root.querySelectorAll('[data-pdp-gallery-thumb]');
    var thumbsTrack = root.querySelector('[data-pdp-gallery-thumbs]');
    if (!viewport || !slides.length) return;

    root.dataset.pdpGalleryInit = 'true';

    var scrollTimer = null;
    var resetTimer = null;
    var hasUserScrolled = false;
    var isResetting = false;
    var activeIndex = 0;
    var desktopMode = DESKTOP_MQ.matches;

    function getSlideScrollLeft(index) {
      var slide = slides[index];
      if (!slide) return 0;
      return Math.max(0, slide.offsetLeft - getViewportPadding(viewport));
    }

    function getActiveIndexFromScroll() {
      var padLeft = getViewportPadding(viewport);
      var scrollLeft = viewport.scrollLeft;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var target = slide.offsetLeft - padLeft;
        var distance = Math.abs(scrollLeft - target);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function setActive(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));

      slides.forEach(function (slide, i) {
        var isActive = i === activeIndex;
        slide.classList.toggle('is-active', isActive);
      });

      dots.forEach(function (dot, i) {
        var isActive = i === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      thumbs.forEach(function (thumb, i) {
        var isActive = i === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (thumbsTrack && thumbs[activeIndex]) {
        thumbs[activeIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }

    function resetToStart(force) {
      if (desktopMode) {
        setActive(0);
        return;
      }

      if (hasUserScrolled && !force) return;

      isResetting = true;
      viewport.style.scrollBehavior = 'auto';
      viewport.scrollLeft = 0;
      viewport.style.scrollBehavior = '';
      setActive(0);
      isResetting = false;
    }

    function scheduleReset(force) {
      if (desktopMode) return;

      window.clearTimeout(resetTimer);
      resetTimer = window.setTimeout(function () {
        resetToStart(force);
        window.requestAnimationFrame(function () {
          resetToStart(force);
        });
      }, 0);
    }

    function scrollToIndex(index) {
      if (desktopMode) {
        setActive(index);
        return;
      }

      hasUserScrolled = true;
      viewport.scrollTo({
        left: getSlideScrollLeft(index),
        behavior: 'smooth'
      });
      setActive(index);
    }

    function onScroll() {
      if (desktopMode || isResetting) return;

      if (viewport.scrollLeft > 2) {
        hasUserScrolled = true;
      }

      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        setActive(getActiveIndexFromScroll());
      }, 60);
    }

    function goRelative(step) {
      var nextIndex = activeIndex + step;
      if (nextIndex < 0) nextIndex = slides.length - 1;
      if (nextIndex >= slides.length) nextIndex = 0;
      scrollToIndex(nextIndex);
    }

    function setDesktopMode(enabled) {
      desktopMode = enabled;
      root.classList.toggle('is-desktop-gallery', enabled);

      if (enabled) {
        hasUserScrolled = false;
        viewport.scrollLeft = 0;
        setActive(activeIndex);
      } else {
        scheduleReset(true);
      }
    }

    viewport.addEventListener('scroll', onScroll, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        if (!isNaN(index)) scrollToIndex(index);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-index'), 10);
        if (!isNaN(index)) scrollToIndex(index);
      });
    });

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-pdp-gallery-prev]')) {
        event.preventDefault();
        goRelative(-1);
        return;
      }

      if (event.target.closest('[data-pdp-gallery-next]')) {
        event.preventDefault();
        goRelative(1);
        return;
      }

      if (event.target.closest('[data-pdp-gallery-thumbs-prev]')) {
        event.preventDefault();
        goRelative(-1);
        return;
      }

      if (event.target.closest('[data-pdp-gallery-thumbs-next]')) {
        event.preventDefault();
        goRelative(1);
      }
    });

    root.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        scheduleReset(false);
      }, { once: true });
      img.addEventListener('error', function () {
        scheduleReset(false);
      }, { once: true });
    });

    function onResize() {
      var nextDesktopMode = DESKTOP_MQ.matches;
      if (nextDesktopMode !== desktopMode) {
        setDesktopMode(nextDesktopMode);
      } else if (!desktopMode) {
        scheduleReset(true);
      }
    }

    window.addEventListener('resize', onResize);

    window.addEventListener('pageshow', function () {
      hasUserScrolled = false;
      if (desktopMode) {
        setActive(0);
      } else {
        scheduleReset(true);
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(function () {
        if (!desktopMode && !hasUserScrolled && viewport.scrollLeft > 2) {
          scheduleReset(true);
        }
      });
      resizeObserver.observe(track);
    }

    if (typeof DESKTOP_MQ.addEventListener === 'function') {
      DESKTOP_MQ.addEventListener('change', onResize);
    } else if (typeof DESKTOP_MQ.addListener === 'function') {
      DESKTOP_MQ.addListener(onResize);
    }

    setDesktopMode(desktopMode);
    scheduleReset(true);
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-pdp-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
